module.exports = __webpack_public_path__ + "staticcomp/img/share.bc3bacb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/1/share.jpg
// module id = SN9G
// module chunks = 39